/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { Maybe } from '@irian-ro/util-functions';

export class VehicleVoModel extends JSONable {
  uuid: Maybe<string> | undefined = undefined;
  licensePlate: Maybe<string> | undefined = undefined;
  vehicleTypeValue: Maybe<string> | undefined = undefined;
}
